import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { SideNavService } from '../../side-nav-components/service/sidenav.service';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'app-feedback-popup',
  templateUrl: './feedback-popup.component.html',
  styleUrls: ['./feedback-popup.component.scss'],
})
export class FeedbackPopupComponent implements OnInit {
  token;
  applicationForm: FormGroup;
  popupType = 'feedback';
  accountId: string;
  contactId: string;
  teamsId = [];

  selectedData = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FeedbackPopupComponent>,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private auth: AuthenticationService,
    private loadingService: LoadingService,
    private userService: UsersService,
    private sidenavService: SideNavService
  ) {}

  ngOnInit(): void {
    this.token = this.auth.getUserAccessToken();
    this.accountId = this.auth.getUserAccountId();
    this.contactId = this.auth.getPrimaryUserId();

    this.applicationForm = this.formBuilder.group({
      angusContactId: ['5b72a549-4bd2-ea11-a813-00224814f90e'],
      selectedTeamMember: [''],
      description: ['', Validators.required],
      subject: ['Feedback'],
      contactId: [this.contactId, Validators.required],
      accountId: [this.accountId, Validators.required],
    });
    this.popupType = this.data.type;
    if (this.popupType == 'messagetoTeam') {
      setTimeout(() => {
        this.getCashelTeam();
      }, 1);
    }
  }
  onSubmit() {
    console.log(this.applicationForm.value);
    if (this.applicationForm.invalid) {
      this.auth.showSnackBarMsg('Please Fill All Options')
      return;
    }
    this.loadingService.startLoading();
    let formdata = {};
    if (this.popupType == 'feedback') {
      formdata = {
        ...this.applicationForm.value,
      };
    } else {
      const allTeamsId = this.selectedData.map((el) => el.value);
      formdata = {
        ...this.applicationForm.value,
        teamid: allTeamsId,
      };
    }

    this.userService.addNotification(this.token, formdata).subscribe(
      (data) => {
        this.loadingService.stopLoading();
        this.dialogRef.close(true);
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg('Something went wrong!')
      }
    );
  }
  getCashelTeam() {
    this.loadingService.startLoading();
    this.sidenavService.getCashelTeam(this.token, this.accountId).subscribe(
      (response) => {
        this.loadingService.stopLoading();
        if (response && response.data && response.data[0]) {
          console.log(response);

          if (response.data[0].owninguser) {
            const data = {
              name: response.data[0].owninguser.fullname,
              value: response.data[0].owninguser.systemuserid,
            };
            this.teamsId.push(data);
            this.addDataInselectionArray({ value: data.value });
          }
          if (response.data[0].new_FinancialPlanner) {
            const data = {
              name: response.data[0].new_FinancialPlanner.fullname,
              value: response.data[0].new_FinancialPlanner.systemuserid,
            };
            this.teamsId.push(data);
            this.addDataInselectionArray({ value: data.value });
          }
          if (response.data[0].new_MortgageBroker) {
            const data = {
              name: response.data[0].new_MortgageBroker.fullname,
              value: response.data[0].new_MortgageBroker.systemuserid,
            };
            this.teamsId.push(data);
            this.addDataInselectionArray({ value: data.value });
          }
          if (response.data[0].new_Associate) {
            const data = {
              name: response.data[0].new_Associate.fullname,
              value: response.data[0].new_Associate.systemuserid,
            };
            this.teamsId.push(data);
            this.addDataInselectionArray({ value: data.value });
          }
        }
      },
      (error) => {
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg('Something Went Wrong, try again after some time.')
        console.log(error);
      }
    );
  }
  addDataInselectionArray(event) {
    const found = this.selectedData.findIndex((el) => {
      return el.value == event.value;
    });
    if (found == -1) {
      const teamdata = this.teamsId.find((el) => el.value == event.value);
      if (teamdata) {
        this.selectedData.push(teamdata);
      }
    }
  }
  saveTeamMemberId(event) {
    console.log('event');
    console.log(event);
    this.applicationForm.get('selectedTeamMember').setValue('');
    const found = this.selectedData.find((el) => {
      return el.value == event.value;
    });

    if (found) {
      this.auth.showSnackBarMsg('Already Selected')
    } else {
      const teamdata = this.teamsId.find((el) => el.value == event.value);
      if (teamdata) {
        this.selectedData.push(teamdata);
      }
    }
  }

  removeteamInUI(value: string) {
    const index = this.selectedData.findIndex((el) => el.value == value);
    if (index > -1) {
      this.selectedData.splice(index, 1);
    }
  }
}
